import { useFormContext } from 'react-hook-form';
import type { ReactElement } from 'react';
import type { PortfolioBuilderInputFields } from './PortfolioBuilder.utils.ts';
import DialogButton from 'components/technical/inputs/GButton/DialogButton.tsx';
import { Save } from '@mui/icons-material';
import { useNavigate } from 'react-router';
import { IPortfolioDefinitionSubType, IPortfolioDefinitionType } from 'generated/graphql.tsx';
import { Stack } from '@mui/joy';
import type { RebalancedDefaultPortfolioDefinitionActionsState } from '../lab/definition/PortfolioDefinitionActions.tsx';
import CreateUpdatePortfolioDialog from '../lab/definition/update/CreateUpdatePortfolioDialog.tsx';

const CreatePortfolioBuilderButton = ({
  portfolioDefinition,
}: {
  portfolioDefinition?: RebalancedDefaultPortfolioDefinitionActionsState;
}): ReactElement => {
  const navigate = useNavigate();
  const { formState, watch } = useFormContext<PortfolioBuilderInputFields>();

  const positions = watch('positions');
  const positionsCompositionInput = Object.values(positions).map((comp) => ({
    id: comp.asset.id,
    weight: Number(comp.weight) / 100,
  }));

  return (
    <Stack direction="row" spacing={1} height={10}>
      <DialogButton
        variant="solid"
        width="normal"
        disabled={Object.keys(formState.errors).length > 0}
        renderDialog={({ onClose }): ReactElement => (
          <CreateUpdatePortfolioDialog
            onClose={onClose}
            onCompleted={() => {
              onClose();
              navigate('/app/copilot/lab/portfolio');
            }}
            def={{
              ...portfolioDefinition,
              id: portfolioDefinition?.id,
              type: IPortfolioDefinitionType.Rebalanced,
              subType: IPortfolioDefinitionSubType.Default,
              realDefAccounts: [],
              realDefSubFunds: [],
              rebalancedDetails: {
                defaultAssetComposition: positionsCompositionInput,
                transactionTag: '',
              },
            }}
            multifactors={[]}
          />
        )}
        startDecorator={<Save />}
      >
        {portfolioDefinition?.id ? 'Update' : 'Save'} portfolio
      </DialogButton>
    </Stack>
  );
};

export default CreatePortfolioBuilderButton;
